import HeroSection from "./HeroSection";
import FloatingInfoBar from "./FloatingInfoBar";

const Banner = () => {
    return (
        <>
            <HeroSection />
            {/* <FloatingInfoBar /> */}
        </>
    );
};

export default Banner;